import { takeLatest, all, call, put, select } from "redux-saga/effects";
import { updateColaborador, allColaboradores as allColaboradoresAction, resetColaborador } from "./actions";
import types from "./types";
import {api} from "../../../services/api";
import consts from "../../../consts";


export function* allColaboradores() {
  const { form } = yield select((state) => state.colaborador);
  try {
    yield put(updateColaborador({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/colaboradores/${consts.id}`);
    
    yield put(updateColaborador({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }


      
    yield put(updateColaborador({ colaboradores: res  }));
  } catch (error) {
    yield put(updateColaborador({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* filterColaboradores() {
  const { form, colaborador } = yield select((state) => state.colaborador);
  try {
    yield put(updateColaborador({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/filter`, {
      filters: { email: colaborador.email, status: "A" },
    });
    yield put(updateColaborador({ form: { ...form, filtering: false } }));
    if (res.error) {
      
      alert(res.message);

      return false;
    }

    if (res.colaboradores.length > 0) {
      yield put(
        updateColaborador({
          colaborador: res.colaboradores[0],
          form: { ...form, filtering: false, disabled: false },
        })
      );
    } else {
      yield put(updateColaborador( {form:{ ...form, disabled: false }} ));
    }
  } catch (error) {
    console.log("fallolu")
    yield put(updateColaborador({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* addColaboradores() {

  const { form, colaborador, components, behavior } = yield select((state) => state.colaborador);

  try {
    yield put(updateColaborador({ form: { ...form, saving: true } }));
    let res = {}
    if(behavior === "create"){

      const response = yield call(api.post, `/colaboradores`, {
       id: consts.clienteId,
       colaborador
  
      });
      res= response.data
    }else{
      const response = yield call(api.put, `/colaboradores/${colaborador.id}`, {
        ...colaborador,
        vinculo:colaborador.vinculo,
        vinculoId:colaborador.vinculoId,
        especialidades: colaborador.especialidades
        
   
       });
       res= response.data
    }
    yield put(updateColaborador({ form: { ...form, saving: false} }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allColaboradoresAction())
    yield put(updateColaborador({ components: { ...components, drawer: false } }))
    yield put(resetColaborador())
  
  } catch (error) {
    yield put(updateColaborador({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}


export function* unlinkColaborador() {
  const { form, colaborador, components } = yield select((state) => state.colaborador);
  try {
    yield put(updateColaborador({ form: { ...form, saving: true } }));
    const { data: res } = yield call(api.delete, `/colaboradores/vinculo/${colaborador.vinculoId}`);
    yield put(updateColaborador({ form: { ...form, saving: false  } ,
    }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allColaboradoresAction())
    yield put(updateColaborador({ components: { ...components, drawer: false , confirmDelete: false} }))
    yield put(resetColaborador())
  
  } catch (error) {
    yield put(updateColaborador({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}
export function* allServicos() {
  const { form } = yield select((state) => state.colaborador);

  try {
    yield put(updateColaborador({ form: { ...form, filtering: true } }));
    const {data:res} = yield call(api.get, `/servicos`)

    
    yield put(updateColaborador({ form: { ...form, filtering: false } }));

    if (res.error) {
   
      alert(res.message);

      return false;
    }

    yield put(updateColaborador({servicos: res}))



  } 
  catch (error) {
    yield put(updateColaborador({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}



export default all([
  takeLatest(types.ALL_COLABORADORES, allColaboradores),
  takeLatest(types.FILTER_COLABORADOR, filterColaboradores),
  takeLatest(types.ADD_COLABORADOR, addColaboradores),
  takeLatest(types.UNLINK_COLABORADOR, unlinkColaborador),
  takeLatest(types.ALL_SERVICES, allServicos),
]);
